import type { FC, PropsWithChildren } from "react";
import * as s from "./Breadcrumbs.module.scss";

const Breadcrumbs: FC<PropsWithChildren> = ({ children }) => (
	<nav>
		<ul
			itemScope
			itemType="https://schema.org/BreadcrumbList"
			className={s.breadcrumbs}
		>
			{children}
		</ul>
	</nav>
);

export default Breadcrumbs;
